import { DataGroupDtoToEntity } from "src/app/features/DataGroup/services/mappers/DataGroupDtoToEntity";
import type { DataGroupDto } from "src/app/features/DataGroup/types/DataGroupDto";
import type { DataGroupEntity } from "src/app/features/DataGroup/types/DataGroupEntity";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";

export const DataGroupPageDtoToEntity = (page: Readonly<ResourcePageDto<DataGroupDto>>): ReadonlyArray<DataGroupEntity> => {
    return page.list ? page.list.map(DataGroupDtoToEntity) : [];
};
